/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 12:12:40
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-30 12:13:41
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/slice/constants.ts
 */
export enum EnumReducers {
  legalEditor = 'legalEditor',
  termsAndConditionEditor = 'termsAndConditionEditor',
}
